import request from '@/utils/request'

export function exportExcel(params) {
  return request({
    url: '/api/financeInfo/exportReturnCoin',
    method: 'post',
    params
  })
}
